import { render } from "./index.vue?vue&type=template&id=271200c8&scoped=true?status=0"
import script from "./index.vue?vue&type=script&lang=js?status=0"
export * from "./index.vue?vue&type=script&lang=js?status=0"

import "./index.vue?vue&type=style&index=0&id=271200c8&lang=less&scoped=true?status=0"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271200c8"]])

export default __exports__